const ENVIRONMENT_TYPES = {
  dev: "dev",
  prod: "prod",
};
const ENVOIRMENT_URL = {
  dev: "http://localhost:9000",
  //prod: "http://18.119.22.33:9000",
  prod: "https://app.gettinby.net",
};

//const selectedEnv = ENVIRONMENT_TYPES.dev;
const selectedEnv = ENVIRONMENT_TYPES.prod;

export const BASE_URL = ENVOIRMENT_URL[selectedEnv];
//export const WEBSOCKET_URL = "wss://localhost:8080";
//export const WEBSOCKET_URL = "ws://18.119.22.33:8080";
export const WEBSOCKET_URL = "wss://app.gettinby.net:8080";
